import * as mutation_types from '../mutation-types';
import * as action_types from '../action-types';

const state = {
    openInfoIconWithLabel: ''
};

const mutations = {
    [mutation_types.SET_OPEN_INFO_LABEL_DATE] (state, date) {
        Vue.set(state, 'openInfoIconWithLabel', date);
    }
};

const getters = {
    [action_types.GET_OPEN_INFO_LABEL_DATE]: (state) => state.openInfoIconWithLabel,
};

export default {
    state,
    mutations,
    getters,
}